/**
 * Top-level navigation out of the embedded-app iframe — for Shopify admin
 * paths such as the theme editor's activateAppId deep link, which must
 * load in the admin itself (not a new tab, not inside our frame).
 *
 * App Bridge patches window.open so `_top` is the supported escape (the
 * same path lib/api.js takes for the OAuth bounce); the direct
 * top-location write is the fallback for non-embedded loads.
 */
export default function openTop(url) {
  if (!url) return false;
  try {
    const opened = window.open(url, '_top');
    if (opened !== null) return true;
  } catch { /* fall through to the location write */ }
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return true;
    }
  } catch { /* cross-origin top */ }
  window.location.assign(url);
  return true;
}
